var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.79312 0 5.77833 1.24822 3.51079 3.51469C-1.17024 8.19345 -1.17024 15.8064 3.51065 20.4852C5.77818 22.7518 8.79312 24 12 24C15.2067 24 18.2217 22.7518 20.4892 20.4852C25.1703 15.8064 25.1703 8.19345 20.4892 3.51469C18.2217 1.24822 15.2067 0 12 0ZM17.4023 17.3996C17.1891 17.6127 16.9098 17.7192 16.6305 17.7192C16.3512 17.7192 16.0718 17.6127 15.8588 17.3996L12 13.5428L8.14125 17.3997C7.92806 17.6127 7.64881 17.7193 7.36947 17.7193C7.09022 17.7193 6.81081 17.6127 6.59784 17.3997C6.17153 16.9737 6.17153 16.283 6.59784 15.8569L10.4565 12L6.59777 8.14305C6.17146 7.71709 6.17146 7.02633 6.59777 6.60029C7.02393 6.17433 7.71502 6.17433 8.14125 6.60029L12 10.4572L15.8586 6.60029C16.2848 6.17433 16.9759 6.17433 17.4021 6.60029C17.8284 7.02625 17.8284 7.71702 17.4021 8.14305L13.5435 12L17.4023 15.8569C17.8285 16.2829 17.8285 16.9737 17.4023 17.3996Z",
    fill: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.03d1feea35f2bbe3d5ded26e0b3ae669.svg";
export { ForwardRef as ReactComponent };